var render = function render(){
  var _vm$program$image;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-card', {
    staticClass: "mb-20 mb-md-40 mb-lg-60",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-img', {
    staticClass: "grey-f7",
    attrs: {
      "src": (_vm$program$image = _vm.program.image) === null || _vm$program$image === void 0 ? void 0 : _vm$program$image.src,
      "aspect-ratio": 772 / 400
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function () {
        return [_c('v-overlay', {
          attrs: {
            "absolute": "",
            "light": "",
            "color": "white"
          }
        }, [_c('image-overlay', [_vm._v(_vm._s(_vm.program.host.name))])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('div', {
    staticClass: "mb-20 mb-md-40 mb-lg-60"
  }, [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16"
  }, [_c('span', [_vm._v(" 기간안내 ")])]), _c('body-date', _vm._b({}, 'body-date', {
    program: _vm.program
  }, false))], 1), _c('div', {
    staticClass: "mb-20 mb-md-40 mb-lg-60"
  }, [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16"
  }, [_c('span', [_vm._v(" 상세정보 ")])]), _c('v-divider', {
    staticClass: "primary border-2 mb-12 mb-lg-24"
  }), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.program.content)
    }
  })], 1), _c('div', {
    staticClass: "mb-20 mb-md-40 mb-lg-60"
  }, [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v(" 문의하기 ")])]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('expo-inquiry-form', _vm._b({
    on: {
      "input": _vm.onInputInquiryForm
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ma-n4 pa-4",
          attrs: {
            "small": "",
            "text": "",
            "height": "27",
            "color": "primary"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          disabled: _vm.disabled
        }), false), on), [_c('span', [_vm._v(" 호스트에게 문의하기 ")]), _c('v-icon', {
          staticClass: "ml-8",
          attrs: {
            "size": "16"
          }
        }, [_vm._v("mdi-chevron-right")])], 1)];
      }
    }])
  }, 'expo-inquiry-form', {
    program: _vm.program
  }, false))], 1)], 1)], 1), _c('expo-inquiry-list', _vm._b({
    ref: "inquiry-list"
  }, 'expo-inquiry-list', {
    program: _vm.program
  }, false))], 1), _c('div', [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16"
  }, [_c('span', [_vm._v(" 연락하기 ")])]), _c('body-info', _vm._b({}, 'body-info', {
    program: _vm.program
  }, false))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }